export default [
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/product-releases/summer-2023/PennyAiBlueP.png',
    altText: 'chatbot penny',
    headline: 'Penny (Gen AI assistant)',
    subheadline:
      'Proprietary AI-powered travel assistant, neighborhood scout, booking support and help desk contact, all in one.'
  },
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/product-releases/summer-2023/LookAround.png',
    altText: 'look around,',
    headline: 'Neighborhood Lookaround',
    subheadline:
      'In-app street level feel for the neighborhood before you book.'
  },
  {
    imageUrl:
      'https://s1.pclncdn.com/design-assets/product-releases/summer-2023/JustforYou.png',
    altText: 'personalized listings',
    headline: 'Just for You recommendations',
    subheadline:
      'Curated hotel recommendations in a personalized view tailored to your interests.'
  }
] as const
